"use client";
import React, { useEffect } from "react";
import "./index.css";
import BaseLayout from "@/components/baseLayout";

const StaticLayout = ({ children }: { children: React.ReactNode }) => {
    return (
        <BaseLayout>
            <div className="h-screen overflow-auto">
                <div className="sticky top-0 z-10">
                    <Header />
                </div>
                <div className="h-full">
                    {children}
                    <div>
                        <Footer />
                    </div>

                </div>
            </div>
        </BaseLayout>
    );
};


const Header = () => {
    useEffect(() => {
        // 汉堡菜单逻辑
        const hamburger = document.querySelector(".hamburger-menu");
        const navLinks = document.querySelector(".nav-links");

        if (hamburger && navLinks) {
            const handleClick = () => {
                navLinks.classList.toggle("active");
                const bars = document.querySelectorAll(".hamburger-menu .bar");
                bars.forEach((bar) => {
                    bar.classList.toggle("change");
                });
            };
            hamburger.addEventListener("click", handleClick);

            // 点击导航链接后关闭菜单
            const links = document.querySelectorAll(".nav-links a");
            links.forEach((link) => {
                link.addEventListener("click", () => {
                    navLinks.classList.remove("active");
                    const bars = document.querySelectorAll(".hamburger-menu .bar");
                    bars.forEach((bar) => {
                        bar.classList.remove("change");
                    });
                });
            });

            // 清理事件
            return () => {
                hamburger.removeEventListener("click", handleClick);
                links.forEach((link) => {
                    link.removeEventListener("click", () => { });
                });
            };
        }
    }, []);

    return (
        <>
            {/* Combined Header and Navigation */}
            <nav className="nav-menu w-full shadow-sm sticky top-0 z-10">
                <div className="logo-container">
                    <a href="/" className="title text-gray-900 tracking-tight">
                        <img
                            src="/images/logo.png"
                            alt="LocalHood"
                            height={24}
                            width={48}
                        />
                    </a>
                </div>
                <div className="hamburger-menu">
                    <span className="bar"></span>
                    <span className="bar"></span>
                    <span className="bar"></span>
                </div>
                <div className="nav-links">
                    <a href="/terms">Terms of Use</a>
                    <a href="/privacy">Privacy Policy</a>
                    <a href="/standards">Community Standards</a>
                    <a href="/legal-notices">Legal Notices</a>
                    <a href="/dsmi">Your Privacy Choices</a>
                    <a href="/trust-center">Trust Center</a>
                </div>
            </nav>
        </>
    );
};

const Footer = () => {
    return (
        <section className="bg-white py-8 mt-8">
            <div className="text-center text-gray-600 text-sm">
                <b>Contact Us</b><br />
                Email:
                <a href="mailto:feedback@zests.ai" className="text-blue-600 underline">
                    feedback@zests.ai
                </a>
                <a href="/contact" className="ml-3 text-blue-600 underline">Contact</a>
                <br />
                Address:
                <span className="text-blue-600 underline"
                >800 W El Camino Real, Suite 310 Mountain View, CA 94040</span>
            </div>
            <div className="text-center text-gray-400 text-xs mt-2 pb-5">
                Copyright © 2025  Life Agents, LLC
            </div>
        </section>
    );
};

export default StaticLayout;